import { map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { UserSettingsAction } from '@cbridge-packages/user-settings';
import { isAlertsPollingEnabledSelector } from '../_selectors/isAlertsPollingEnabled.selector';
import { AlertsDashboardAction } from '../alertsDashboard.action';
import { ALERTS_POLLING_SETTING_KEY } from '../alertsDashboard.constans';

type IState = IGetSelectorStateType<typeof isAlertsPollingEnabledSelector>;

/** Only the user's play/pause click is remembered; the init switch (`setPollingEnabled`) is not. */
export const persistAlertsPollingEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(AlertsDashboardAction.togglePolling),
  withLatestFrom(state$),
  map(([, state]) => UserSettingsAction.saveSetting({
    key: ALERTS_POLLING_SETTING_KEY,
    value: Boolean(isAlertsPollingEnabledSelector(state)),
  })),
);
